import Login from "../Component/LoginForm/LoginForm";
import logo from "../assets/images/Icons_and_images/logo.jpg";
import "../Component/LoginForm/Loginbackstyle.css";
import "@fontsource/plus-jakarta-sans";
function LoginandRegistration() {
  return (
    <div className="container-fluid px-0">
      <div className="freebg d-flex align-items-center justify-content-center ">
        <div>
          <div className="row  ">
            <div className="col-12  ">
              <div className="formback h-auto mx-md-auto rounded ">
                <form>
                  <div className="row mx-0">
                    <div className="col-12 col-md-6 d-flex algin-items-center justify-content-center px-0 ">
                      <div className="p-3  log-wd ">
                        <div className=" text-center text-sm-left">
                          <img src={logo} alt="logo" className="img-fluid" />
                        </div>
                        <div className="pt-4 pb-3 ">
                          <h3>
                            <b>Avoid delays & Save</b>
                          </h3>
                          <h3>
                            <b>upto 7% on project costs</b>
                          </h3>
                          <ul className="p-0" id="courselist1">
                            <li className="pricepad">
                              Get better site visibility of your all
                              construction projects
                            </li>
                            <li className="pricepad fontstt">
                              Streamline your labour management process
                            </li>
                            <li className="pricepad">
                              Efficient material management
                            </li>
                          </ul>

                          {/* <button
                                type="submit"
                                className="next-btn1"
                                //   name="submit"
                                align="left"
                                disabled
                                //   disabled={!(nameValid && phnoValid)}
                              >
                                <b>
                                  Next &nbsp;&nbsp; <span>&#8594;</span>
                                </b>
                              </button> */}
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-md-6 d-flex algin-items-center justify-content-center px-0">
                      <div className=" d-flex align-items-center p-3">
                        <Login />
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default LoginandRegistration;
